/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchFromJSON, FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchToJSON, } from './FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch';
/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse(value) {
    if (!('Branches' in value) || value['Branches'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseFromJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Branches': (json['Branches'].map(FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchFromJSON)),
    };
}
export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseToJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Branches': (value['Branches'].map(FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse.js.map